module.exports = __webpack_public_path__ + "static/media/doc.6068ce12.svg";